export const addGadgetPanelId = 'addGadgetPanel';
